import PropTypes from 'prop-types'

export const ConverterTypes = { input: PropTypes.func, output: PropTypes.func }
